import { gql } from '@apollo/client'

export const MARK_ALL_FOLLOWED_AS_PLAYED = gql`
  mutation markAllFollowedAsPlayed {
    markAllFollowedAsPlayed
  }
`
